export enum RoomType {
  LOUNGE = "LOUNGE",
  ACCOMMODATION = "ACCOMMODATION",
  ENTRANCE_AREA = "ENTRANCE_AREA",

  ELEVATOR_SHAFT = "ELEVATOR_SHAFT",
  PARKING_GARAGE = "PARKING_GARAGE",
  UNDERGROUND_CAR_PARK = "UNDERGROUND_CAR_PARK",

  HOTEL_ROOM = "HOTEL_ROOM",
  WELLNESS_AREA = "WELLNESS_AREA",

  OFFICE = "OFFICE",
  MEETING_ROOM = "MEETING_ROOM",
  MEETING_BOOTH = "MEETING_BOOTH",

  CAFETERIA = "CAFETERIA",
  CANTEEN = "CANTEEN",
  RESTAURANT = "RESTAURANT",

  DRESSING_ROOM = "DRESSING_ROOM",
  STORAGE = "STORAGE",

  TOILET = "TOILET",
  BATHROOM = "BATHROOM",

  EVENT_SPACE = "EVENT_SPACE",

  WORKSHOP = "WORKSHOP",
  PAINT_SHOP = "PAINT_SHOP",
  WELDING_SHOP = "WELDING_SHOP",
  COOKING_CLASS = "COOKING_CLASS",

  CLASSROOM = "CLASSROOM",
  SEMINAR_ROOM = "SEMINAR_ROOM",
  SCIENCE_LABS = "SCIENCE_LABS",
  MUSIC_ROOM = "MUSIC_ROOM",
  LECTURE_HALL = "LECTURE_HALL",

  SPECIAL_RESEARCH_AREA = "SPECIAL_RESEARCH_AREA",
  HAZARDOUS_MATERIALS_STORAGE = "HAZARDOUS_MATERIALS_STORAGE",
  LABORATORY = "LABORATORY",
  CLEANROOM = "CLEANROOM",
  EXPLOSION_PROOF_AREA = "EXPLOSION_PROOF_AREA",

  HOSPITAL_AND_CLINIC = "HOSPITAL_AND_CLINIC",
  TREATMENT_ROOM = "TREATMENT_ROOM",
  OPERATING_ROOM = "OPERATING_ROOM",
  QUARANTINE_ROOM = "QUARANTINE_ROOM",
  HYGENIC_ROOM = "HYGIENIC_ROOM",

  KITCHEN = "KITCHEN",
  DINING_ROOM = "DINING_ROOM",
  BED_ROOM = "BED_ROOM",
  LIVING_ROOM = "LIVING_ROOM",

  LIBRARY_ARCHIVE_CENTER = "LIBRARY_ARCHIVE_CENTER",

  LAUNDRY = "LAUNDRY",

  MUSEUM_EXHIBITION = "MUSEUM_EXHIBITION",

  DATA_CENTER = "DATA_CENTER",

  MAGAZINE_DEPOT = "MAGAZINE_DEPOT",
  HANGAR = "HANGAR",
  TERMINAL = "TERMINAL",

  AQUATICS_CENTER = "AQUATICS_CENTER",
  SPORTS_HALL = "SPORTS_HALL",
  GYMNASTICS_ROOM = "GYMNASTICS_ROOM",
  FITNESS_STUDIO = "FITNESS_STUDIO",
  ICE_RINK = "ICE_RINK",

  RECORDING_ROOM = "RECORDING_ROOM",

  CINEMA_HALL = "CINEMA_HALL",

  SHOP = "SHOP",
  MALL = "MALL",

  CHURCH = "CHURCH",

  PRODUCTION_HALL = "PRODUCTION_HALL",

  AGGRESSIVE_EXHAUST = "AGGRESSIVE_EXHAUST"
}
